import{styled as o}from"styled-components";import{FieldHighLabel as t}from"../../base/Label/Label.mjs";const e=o(t)`
  float: left;
`;export{e as LeftFloatLabel};
